import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Redirect, Switch } from "react-router-dom";
import { Elements, StripeProvider } from "react-stripe-elements";
import { ConnectedRouter } from "connected-react-router";

import { attemptRetrieveOrder } from "./store/thunks/order";
import { updateMaxStep } from "./store/actions/order";

import routes from "./routes.js";
import ProtectStep from "./components/common/ProtectStep";

import Navbar from "./components/common/Navbar";
import Layout from "./components/common/Layout";
import Footer from "./components/common/Footer";

import GetStarted from "./components/pages/GetStarted";
import Template from "./components/pages/Template";
import Guestlist from "./components/pages/Guestlist";
import Order from "./components/pages/order/index";

const App = props => {
  const { history } = props;
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const orderId = localStorage.getItem("order_id");
    const maxStep = localStorage.getItem("max_step");
    if (orderId) {
      dispatch(attemptRetrieveOrder(orderId))
        .then(() => {
          if (maxStep) {
            dispatch(updateMaxStep(maxStep));
          }
          setLoading(false);
        })
        .catch(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <ConnectedRouter history={history} basename={"/"}>
        <StripeProvider apiKey={process.env.REACT_APP_STRIPE_KEY}>
          <div className="container d-flex flex-column min-h-100">
            <Navbar />
            <Layout>
              {loading ? (
                <div className="dots dots-primary"></div>
              ) : (
                <Switch>
                  <ProtectStep
                    step={1}
                    path={routes.getstarted}
                    exact
                    component={GetStarted}
                    wait={loading}
                  />
                  <ProtectStep
                    step={2}
                    path={routes.template}
                    exact
                    component={Template}
                    wait={loading}
                  />
                  <ProtectStep
                    step={3}
                    path={routes.guestlist}
                    exact
                    component={Guestlist}
                    wait={loading}
                  />
                  <Elements>
                    <ProtectStep
                      step={4}
                      path={routes.order}
                      exact
                      component={Order}
                      wait={loading}
                    />
                  </Elements>

                  <Redirect to="/" />
                </Switch>
              )}
            </Layout>
            <Footer />
          </div>
        </StripeProvider>
      </ConnectedRouter>
    </>
  );
};

export default App;
